<template>
<v-dialog v-model="internalShow" persistent max-width="500px">
    <v-card class="pa-4">
        <v-card-title class="text-h6 font-weight-bold">
            {{ $t('successTitle') }}
            <v-spacer></v-spacer>
            <v-btn @click="closeModal" icon>
                <v-icon>fas fa-times</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="text-center text-body-1 mt-2">
            <span class="font-weight-medium">{{ model.fullName }}</span>, {{ $t('successMessage') }}
        </v-card-text>

        <v-divider class="my-3"></v-divider>

        <v-card-text class="text-body-1">
            {{ $t('verification') }}
        </v-card-text>
        <v-card-actions class="justify-center">
            <v-btn color="green" dark :href="whatsappLink" target="_blank">
                <v-icon left>fab fa-whatsapp</v-icon> Verifikuj putem WhatsApp-a
            </v-btn>
        </v-card-actions>
        <v-card-text class="text-body-1">
            {{ $t('verification2') }}
        </v-card-text>
        <v-card-text class="text-h6 font-weight-bold text-center">
            {{ phone }}
        </v-card-text>

        <v-card-text class="text-body-2 text-center">
            {{ $t('verification1') }}
        </v-card-text>

        <!-- QR Code Section -->
        <v-card-text class="text-center">
            <div class="mb-2">Ili skenirajte QR kod:</div>
            <div ref="qrCode"></div>
        </v-card-text>

        <v-card-actions class="justify-end">
            <v-btn color="green darken-1" text @click="closeModal">OK</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import QRCode from 'qrcode-generator';

export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
        },
        specificText: {
            type: Object,
        },
        projectId: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            internalShow: this.show,
            phone: '',
            text: 'VERIFICIRAJ',
        };
    },
    computed: {
        whatsappLink() {
            return `https://api.whatsapp.com/send/?phone=${this.phone}&text=${this.text}&type=phone_number&app_absent=0`;
        }
    },
    watch: {
        show(val) {
            this.internalShow = val;
            if (val) {
                this.$nextTick(() => {
                    this.generateQRCode();
                });
            }
        },
        internalShow(val) {
            this.$emit('update:show', val);
        },
        phone() {
            this.$nextTick(() => {
                this.generateQRCode();
            });
        }
    },
    created() {
        this.getInstace();
    },
    methods: {
        generateQRCode() {
            if (!this.phone) return;

            // Clear previous QR code
            if (this.$refs.qrCode) {
                this.$refs.qrCode.innerHTML = '';
            }

            // Generate new QR code
            const qr = QRCode(0, 'L');
            qr.addData(this.whatsappLink);
            qr.make();

            // Create an img element and set the QR code as its source
            const qrCodeImg = qr.createImgTag(4);
            if (this.$refs.qrCode) {
                this.$refs.qrCode.innerHTML = qrCodeImg;
            }
        },
        sendWhatsAppMessage(phone, text) {
            const baseUrl = "https://api.whatsapp.com/send/";
            const url = `${baseUrl}?phone=${phone}&text=${text}&type=phone_number&app_absent=0`;
            window.location.href = url;
        },
        async getInstace() {
            const url = new URL('https://sparkprize.azurewebsites.net/api/v2/WaapiInstances/rotator/' + this.projectId);

            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json'
                    }
                });

                if (response.ok) {
                    var data = await response.json()
                    this.phone = data.Instance.Phone;
                }
            } catch (error) {
                console.error('Error:', error);
            }
        },
        closeModal() {
            this.internalShow = false;
            window.location.reload();
        },
        closeModalWithoutReload() {
            this.internalShow = false;
        }
    }
};
</script>

<style scoped>
.title {
    text-align: center;
    font-weight: bold;
    font-size: 28px;
}

.full-name {
    text-align: center;
    font-weight: bold;
    font-size: 20px;
}

.thak-you {
    text-align: center;
    font-size: 18px;
}
</style>
